import { createNameContext } from '@showroomjs/ui';
import * as React from 'react';
export const CodeblocksContext = createNameContext('ShowroomCodeblocksContext', {});
export const useCodeBlocks = () => React.useContext(CodeblocksContext);
//# sourceMappingURL=codeblocks-context.js.map